<template>
  <div class="erpc-basic-settings p-b-15">
    <div class="erpc-basic-settings__section-heading">
      {{ $t('PRIORITY_NEW_TARGETS_SLIDER_TITLE') }}
      <i
        v-tooltip.right="$t('PRIORITY_NEW_TARGETS_SLIDER_TITLE_TT')"
        class="fa fa-question-circle m-l-5"
      />
    </div>
    <div class="row m-b-15">
      <div>
        <vue-slider
          v-model="erpcSettingBasic.newTargetPriority"
          class="vue-slider-v1 flex--grow"
          :tooltip="'none'"
          :height="15"
          :marks="newTargetPriorityMarks"
        >
          <template v-slot:dot>
            <div class="vue-slider-dot-handle">
              <i class="fa fa-ellipsis-v" aria-hidden="true" />
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
    <div class="erpc-basic-settings__section-heading">
      {{ $t('PRIORITY_UP_TARGETS_SLIDER_TITLE') }}
      <i
        v-tooltip.right="$t('PRIORITY_UP_TARGETS_SLIDER_TITLE_TT')"
        class="fa fa-question-circle m-l-5"
      />
    </div>
    <div class="row m-b-15">
      <div>
        <vue-slider
          v-model="erpcSettingBasic.underPerformingTargetPriority"
          class="vue-slider-v1 flex--grow"
          :tooltip="'none'"
          :height="15"
          :marks="underPerformingTargetPriorityMarks"
        >
          <template v-slot:dot>
            <div class="vue-slider-dot-handle">
              <i class="fa fa-ellipsis-v" aria-hidden="true" />
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
    <div class="erpc-basic-settings__section-heading">
      {{ $t('STABILITY_SLIDER_TITLE') }}
      <i
        v-tooltip.right="$t('STABILITY_SLIDER_TITLE_TT')"
        class="fa fa-question-circle m-l-5"
      />
    </div>
    <div class="row m-b-15">
      <div>
        <vue-slider
          v-model="erpcSettingBasic.stability"
          class="vue-slider-v1 flex--grow"
          :tooltip="'none'"
          :height="15"
          :marks="stabilityMarks"
        >
          <template v-slot:dot>
            <div class="vue-slider-dot-handle">
              <i class="fa fa-ellipsis-v" aria-hidden="true" />
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'ERPCSettingsBasic',
  components: {
  },
  props: {
    erpcSettingBasic: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      newTargetPriorityMarks: {
        0: {
          label: this.$t('LOW'),
          labelStyle: {
            left: '7px',
            transform: 'translateX(0)'
          }
        },
        55: {
          label: this.$t('DEFAULT')
        },
        100: {
          label: this.$t('HIGH'),
          labelStyle: {
            right: '7px',
            left: 'auto',
            transform: 'translateX(0)'
          }
        }
      },
      underPerformingTargetPriorityMarks: {
        0: {
          label: this.$t('LOW'),
          labelStyle: {
            left: '7px',
            transform: 'translateX(0)'
          }
        },
        10: {
          label: this.$t('DEFAULT')
        },
        100: {
          label: this.$t('HIGH'),
          labelStyle: {
            right: '7px',
            left: 'auto',
            transform: 'translateX(0)'
          }
        }
      },
      stabilityMarks: {
        0: {
          label: this.$t('REACTIVE'),
          labelStyle: {
            left: '7px',
            transform: 'translateX(0)'
          }
        },
        45: {
          label: this.$t('DEFAULT')
        },
        100: {
          label: this.$t('STABLE'),
          labelStyle: {
            right: '7px',
            left: 'auto',
            transform: 'translateX(0)'
          }
        }
      },
    }
  },
  methods: {
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>